var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{attrs:{"outlined":"","rules":_vm.isItRequired,"label":_vm.generateLabel,"value":_vm.value || _vm.field.default,"disabled":_vm.isDisabled,"counter":_vm.hasLimit ? _vm.limit : null,"maxlength":_vm.hasLimit ? _vm.limit : null,"dense":"","hint":_vm.field.hint},on:{"change":_vm.handleTextChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }